import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, AlertTriangle } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    const target = document.getElementById('offer');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 2000;
    let startTime: number | null = null;
    function animation(currentTime: number) {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }
    requestAnimationFrame(animation);
  };
  return <Section background="darker" className="border-t border-slate-900 relative overflow-hidden py-24" data-id="element-17">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 opacity-90 z-0" data-id="element-18"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-brand-orange/5 blur-[120px] rounded-full -z-10" data-id="element-19"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-21">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-500/20 mb-8" data-id="element-22">
            <AlertTriangle className="w-4 h-4 text-red-500" data-id="element-23" />
            <span className="text-red-500 text-xs font-bold uppercase tracking-widest" data-id="element-24">
              Warning: Time is a Factor
            </span>
          </div>

          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white uppercase mb-8 leading-tight" data-id="element-25">
            Your Knees Are <br data-id="element-26" />
            <span className="text-brand-orange" data-id="element-27">Keeping Score</span>
          </h2>

          <div className="prose prose-lg prose-invert mx-auto mb-12 text-slate-300" data-id="element-28">
            <p className="text-xl leading-relaxed" data-id="element-29">
              Six months from now, you will be in one of two places.
            </p>
            <p data-id="element-30">
              <strong className="text-white" data-id="element-31">Place one:</strong> You ignored
              this page, kept doing what you have been doing, and your knees are
              worse. The belly is bigger. You have quietly accepted the "old
              man" identity you are fighting.
            </p>
            <p data-id="element-32">
              <strong className="text-white" data-id="element-33">Place two:</strong> You spent $6.36
              today. You followed the plan. You are 15 lbs lighter, your knees
              feel 10 years younger, and you are playing with your grandkids
              without a second thought.
            </p>
            <p className="text-white font-bold italic text-lg" data-id="element-34">
              The choice is yours. But the clock is ticking on your joints.
            </p>
          </div>

          <Button size="xl" onClick={scrollToOffer} className="w-full md:w-auto text-xl px-12 py-6 shadow-2xl shadow-brand-orange/20 animate-pulse hover:animate-none" data-id="element-35">
            Yes, I Want Pain-Free Fat Loss{' '}
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-36" />
          </Button>

          <p className="mt-6 text-slate-500 text-sm" data-id="element-37">
            Backed by our 30-Day "Old Man" Money-Back Guarantee
          </p>
        </motion.div>
      </div>
    </Section>;
}